import React from 'react';
import { typography } from '../../styles/typography';

const DeleteRideWarning = ({ onCancel, onConfirm, isVisible = false }) => {
  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
      <div className="w-[464px] px-8 py-6 bg-neutral-50/50 rounded-xl shadow-[0px_15px_30px_0px_rgba(0,0,0,0.10)] shadow-[0px_5px_20px_0px_rgba(255,255,255,0.10)] shadow-[inset_0px_4px_25px_0px_rgba(255,255,255,0.35)] outline outline-1 outline-offset-[-1px] outline-neutral-300/20 backdrop-blur-[30px] inline-flex flex-col justify-start items-start gap-10 overflow-hidden">
        {/* Header Section */}
        <div className="self-stretch inline-flex justify-between items-center">
          <div className={`${typography.h2} text-black`}>
            Warning
          </div>
          <button 
            onClick={onCancel}
            className="w-12 h-12 relative bg-stone-950/10 rounded overflow-hidden hover:bg-stone-950/20 transition-colors duration-200 cursor-pointer"
          >
            <div className="w-6 h-6 left-[12px] top-[12px] absolute overflow-hidden flex items-center justify-center">
              <svg 
                width="24" 
                height="24" 
                viewBox="0 0 24 24" 
                fill="none" 
                xmlns="http://www.w3.org/2000/svg"
                className="text-zinc-950"
              >
                <path 
                  d="M18 6L6 18M6 6L18 18" 
                  stroke="currentColor" 
                  strokeWidth="2" 
                  strokeLinecap="round" 
                  strokeLinejoin="round"
                />
              </svg>
            </div>
          </button>
        </div>

        {/* Content Section */}
        <div className="self-stretch flex flex-col justify-start items-start gap-4">
          {/* Warning Message */}
          <div className="mb-4 text-center">
            <p className={typography.p} style={{color: '#000000'}}>
              Are You Sure, Do you want to DELETE the Scheduled Ride?
            </p>
          </div>

          {/* Action Buttons */}
          <div className="self-stretch inline-flex justify-start items-start gap-6">
            {/* Cancel Button */}
            <button
              onClick={onCancel}
              className="w-48 h-14 px-6 py-3 bg-green-700 rounded-lg inline-flex flex-col justify-center items-center gap-2.5 hover:bg-green-800 transition-colors duration-200"
            >
              <div className={`${typography.h5} text-center justify-center text-white`}>
                Cancel
              </div>
            </button>

            {/* Confirm Delete Button */}
            <button
              onClick={onConfirm}
              className="w-48 h-14 px-6 py-3 bg-white rounded-lg outline outline-1 outline-offset-[-1px] outline-red-500 inline-flex flex-col justify-center items-center gap-2.5 hover:bg-red-50 transition-colors duration-200"
            >
              <div className={`${typography.h5} text-center justify-center text-red-500`}>
                Yes, Delete
              </div>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeleteRideWarning;

